import { render, staticRenderFns } from "./PlanBilling.vue?vue&type=template&id=612ab612&"
import script from "./PlanBilling.vue?vue&type=script&lang=js&"
export * from "./PlanBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports